import { api, PostStudyLogPayload } from '@/api';
import { useStudyGuard } from '@/shared/guard';

export const useCreateStudyLog = () => {
  const { studyId } = useStudyGuard();

  const postActivityLogMutation = api.apps.studyLog.mutation.usePostStudyLog();

  const createStudyLog = (payload: Partial<PostStudyLogPayload>, onSuccess?: () => void) => {
    if (!payload.body) {
      return;
    }

    const postStudyLogPayload: PostStudyLogPayload = {
      body: payload.body,
      studyId,
    };

    postActivityLogMutation.mutate({ payload: postStudyLogPayload }, { onSuccess });
  };

  return createStudyLog;
};
